export const setAdditionalClasses = (classnames, conditions) => {
  let finalClasses = " ";
  for (let i = 0; i < classnames.length; i++) {
    if (conditions[i]) finalClasses += `${classnames[i]} `;
  }
  return finalClasses;
};

export const shiftImageIndex = (currentIndex, forward, totalLength) => {
  if (forward) {
    if (currentIndex === totalLength - 1) return 0;
    else return currentIndex + 1;
  } else {
    if (currentIndex === 0) return totalLength - 1;
    else return currentIndex - 1;
  }
};

export const getRightContent = (rtl, contentList) =>
  rtl ? contentList[1] : contentList[0];

export const getVisibleSensorAnimation = (isVisible, animation) => ({
  animation: isVisible ? animation : "",
  opacity: !isVisible ? 0 : 1,
});

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const getSectionContent = (currentSection, sectionList = []) => {
  return sectionList[currentSection];
};

export const getAnimationNameBasedOnList = (
  index,
  length,
  animationNames = ["fadeInLeft", "fadeIn", "fadeInRight"]
) => {
  if (length % 2 === 0) {
    if (index % 2 === 0) return animationNames[0];
    else return animationNames[2];
  } else {
    if (index === 0) return animationNames[0];
    else if (index === 1) return animationNames[1];
    else return animationNames[2];
  }
};

export const getAnimationNameBasedOnListWIthSeparators = (
  index,
  length,
  animationNames = ["fadeInLeft", "fadeIn", "fadeInRight"]
) => {
  if (length % 2 === 0) {
    if (index % 2 === 0) return animationNames[0];
    else return animationNames[2];
  } else {
    if (index === 0) return animationNames[0];
    else if (index === 2 && length !== index + 1) return animationNames[1];
    else return animationNames[2];
  }
};
